import { render, staticRenderFns } from "./CustomAnswerForm.vue?vue&type=template&id=35dc699a&scoped=true&"
import script from "./CustomAnswerForm.vue?vue&type=script&lang=js&"
export * from "./CustomAnswerForm.vue?vue&type=script&lang=js&"
import style0 from "./CustomAnswerForm.vue?vue&type=style&index=0&id=35dc699a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35dc699a",
  null
  
)

export default component.exports